import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { ConditionType } from "../types/ConditionTypeList";

const fetchConditionTypes = (authHeader: string) => () =>
  axios.get<ConditionType[]>(`${env.verifyServiceUrl}common/condition_type_list/`, {
    headers: {
      Authorization: authHeader,
    },
  });
export const useConditionTypeList = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["conditionType"], fetchConditionTypes(authHeader), {
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};
